import { InputNumberProps, InputProps } from '@easyv/react-components';
import * as React from 'react';
import { ProInputNumber } from './ProInputNumber';

interface ProInputPercentNumberProps
  extends Omit<
    InputNumberProps,
    'onChange' | 'value' | 'onBlur' | 'onPointMoveStart' | 'onPointMoveEnd'
  > {
  precisionOnShow?: number;
  precisionOnSave?: number;
  name: string;
  value: number;
  min?: number;
  max?: number;
  onChange?: (name: string, value: number) => void;
  onBlur: (name: string, value: number) => void;
  onPointMoveStart: (name: string, value?: number) => void;
  onPointMoveEnd: (name: string, value: number) => void;
}

export const ProInputPercentNumber: React.FC<ProInputPercentNumberProps> = (props) => {
  const { name, value, min = 0, max = 100, suffix = '%', onBlur, onChange, ...rest } = props;

  const realToInputValue = React.useCallback((value: number) => {
    return value * 100;
  }, []);

  const inputToRealValue = React.useCallback((value: number) => {
    return value / 100;
  }, []);

  return (
    <ProInputNumber
      name={name}
      value={value}
      min={min}
      max={max}
      suffix={suffix}
      onBlur={onBlur}
      onChange={onChange}
      realToInputValue={realToInputValue}
      inputToRealValue={inputToRealValue}
      {...rest}
    />
  );
};
